<template>
  <div class="content">
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>能耗管理</el-breadcrumb-item>
            <el-breadcrumb-item>能耗统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;overflow-y: auto;" class="aside">
          <div
            style="height:49%;width:100%;display:flex;justify-content: space-between;margin-bottom:1%"
          >
            <el-card class="box-card" style="width:60%;height:100%;background:#fff;">
              <el-select class="contenttxt-year" v-model="getTime">
                <el-option
                  v-for="item in groups3"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <div class="echart">
                <div id="myChart1" :style="{ height: '100%' }"></div>
              </div>
            </el-card>
            <el-card class="box-card" style="width:39%;height:100%">
              <div class="month-pie">
                <span class="el-dropdown-link"></span>
              </div>
              <div class="grid-content bg-purple">
                <div class="echart">
                  <div id="erChart2" :style="{ width: '400px', height: '300px' }"></div>
                </div>
              </div>
            </el-card>
          </div>
          <div style="height:50%;width:100%;display:flex;justify-content: space-between;">
            <el-card class="box-card" style="width:60%;height:100%">
              <el-select class="contenttxt-year" v-model="year" @change="setWater">
                <el-option
                  v-for="item in groups"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <div class="echart">
                <div id="myChart3" :style="{ height: '100%' }"></div>
              </div>
            </el-card>
            <el-card class="box-card" style="width:39%;height:100%">
              <div class="month-pie">
                <span class="el-dropdown-link"></span>
              </div>
              <div class="grid-content bg-purple">
                <div class="echart">
                  <div id="myChart4" :style="{ width: '400px', height: '300px' }"></div>
                </div>
              </div>
            </el-card>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import echarts from 'echarts' //引入echarts
import HighCharts from 'highcharts'
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
export default {
  name: 'eCharts',
  data() {
    return {
      allAtten: {},
      allGath: {},
      // 年加月
      groups3: [],
      groups:[],
      getTime: '', //当前
      year:'',
      groupId: '',
      elePie:[0,0,0,0],//电环形
      waterPie:[0,0,0,0],//水环形
    }
  },
  watch: {
    // groupId: {
    //   handler(newVal) {
    //     this.getData();
    //     this.getDataLine();
    //   },
    //   immediate: true,
    //   deep: true
    // },
    year: {
      handler(newVal) {
        // this.getDataLine()
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.getYears()
    // this.groups =this.groups3
    // this.drawLine();
    if (util.session.get('roleId') != '4') {
      this.groupId = util.session.get('proId')
    } else {
      this.groupId = util.session.get('groupId')
    }
    // var getDate = new Date().getMonth() + 1

    // getDate = getDate < 10 ? '0' + getDate : getDate
    this.getTime = new Date().getFullYear()
    this.year = new Date().getFullYear()
    this.drawLine()
    this.getEchart1()
    this.getEchart3()
    //获取数据
    this.getData()
    this.getData1()
    this.getQuarterData()
  },
  methods: {
    //获取年份
    getYears(){
      this.groups3 = []
      this.groups=[]
      var cur = new Date().getFullYear()
      for(var i=-10;i<10;i++){
        this.groups.push(parseInt(cur)+i)
        this.groups3.push(parseInt(cur)+i)
      }
    },

    /**
     * 获取用电数据
     */
    getData(){
      var that = this
      myHttp.selectWaterElectricityRecord({
        groupId:this.groupId,
        date:this.getTime,
        type:'2'
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.List||[]
          var obj = []
          for(var i=0;i<list.length;i++){
            obj.push(parseFloat(list[i].useOf))
          }
          that.elePie = []
          that.getEchart1(obj)
          that.elePie.push(parseFloat(list[0].useOf)+parseFloat(list[1].useOf)+parseFloat(list[2].useOf))
          that.elePie.push(parseFloat(list[3].useOf)+parseFloat(list[4].useOf)+parseFloat(list[5].useOf))
          that.elePie.push(parseFloat(list[6].useOf)+parseFloat(list[7].useOf)+parseFloat(list[8].useOf))
          that.elePie.push(parseFloat(list[9].useOf)+parseFloat(list[10].useOf)+parseFloat(list[11].useOf))
          that.drawLine()
        }
      })
    },

    /**
     * 监听用水时间
     */
    setWater(){
      this.getData1()
      this.getQuarterData()
    },
    /**
     * 获取用水数据
     */
    getData1(){
      var that = this
      myHttp.selectWaterElectricityRecord({
        groupId:this.groupId,
        date:this.year,
        type:'1'
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.List||[]
          var obj = []
          for(var i=0;i<list.length;i++){
            obj.push(parseFloat(list[i].useOf))
          }
          that.getEchart3(obj)
          
        }
      })
    },
    /**
     * 获取用水季度统计
     */
    getQuarterData(){
      var that = this
      myHttp.selectWaterByQuarter({
        projectId:this.groupId,
        year:this.year,
        type:'1'
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          var list = resp.data.data.yearWater||[]
          that.waterPie = []
          that.waterPie.push(parseFloat(list[0].allCalculateUseOf))
          that.waterPie.push(parseFloat(list[1].allCalculateUseOf))
          that.waterPie.push(parseFloat(list[2].allCalculateUseOf))
          that.waterPie.push(parseFloat(list[3].allCalculateUseOf))
          that.drawLine()
        }
      })
    },

    getEchart1(list) {
      list = list?list:[0,0,0,0,0,0,0,0,0,0,0,0]
      var chart = HighCharts.chart('myChart1', {
        chart: {
          type: 'column',
        },
        title: {
          text: '用电统计(单位：千瓦时)',
        },
        subtitle: {
          // text: '数据来源: WorldClimate.com',
        },
        xAxis: {
          categories: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月',
          ],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: '用电统计(单位：千瓦时)',
          },
        },
        tooltip: {
          // head + 每个 point + footer 拼接成完整的 table
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f} WH</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            borderWidth: 0,
          },
        },
        series: [
          {
            name: '用电',
            data: list,
          },
        ],
      })
    },
    getEchart3(list) {
      list = list?list:[0,0,0,0,0,0,0,0,0,0,0,0]
      var chart = HighCharts.chart('myChart3', {
        chart: {
          type: 'area',
        },
        title: {
          text: '用水统计(吨)',
        },
        subtitle: {
          // text: '数据来源: <a href="https://thebulletin.metapress.com/content/c4120650912x74k7/fulltext.pdf">' +
          // 'thebulletin.metapress.com</a>'
        },
        xAxis: {
            categories: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月',
          ],
          crosshair: true,
        },
        yAxis: {
          title: {
            text: '用水统计(吨)',
          },
          labels: {
            formatter: function () {
              return this.value / 1000 + 'T'
            },
          },
        },
        tooltip: {
          pointFormat: '{series.name}  <b>{point.y:,.0f}</b>吨',
        },
        plotOptions: {
          area: {
            // pointStart: ,
            // marker: {
            //   enabled: false,
            //   symbol: 'circle',
            //   radius: 2,
            //   states: {
            //     hover: {
            //       enabled: true,
            //     },
            //   },
            // },
          },
        },
        series: [
          {
            name: '用水量',
            data: list,
          },
        ],
      })
    },
    drawLine() {
      var myChart2 = this.$echarts.init(document.getElementById('erChart2'))
      var myChart4 = this.$echarts.init(document.getElementById('myChart4'))
      var eleTotal = this.elePie[0]+this.elePie[1]+this.elePie[2]+this.elePie[3]
      myChart2.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        // legend: {
        //   orient: 'vertical',
        //   left: 10,
        //   data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
        // },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          z: 2,
          style: {
            text: '总用电量' + eleTotal + '千瓦时',
            x: 100,
            y: 100,
            textAlign: 'center',
            fill: '#1B3BF5',
            width: 30,
            height: 30,
            fontSize: 12,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: '用电统计',
            type: 'pie',
            radius: ['42%', '64%'],
            hoverAnimation: false,
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = ['#F8B51F', '#F65D26', '#AEC9FF', '#248EFF']
                  return colorList[params.dataIndex]
                },
              },
            },
            label: {
              normal: {
                show: true,
                position: 'outside',
                formatter: '{b}\n{c}千瓦时',
                textStyle: {
                  fontSize: '12',
                  fontWeight: 'bold',
                },
                emphasis: {
                  show: true,
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: true,
            },
            data: [
              { value: this.elePie[0], name: '一季度' },
              { value: this.elePie[1], name: '二季度' },
              { value: this.elePie[2], name: '三季度' },
              { value: this.elePie[3], name: '四季度' },
            ],
          },
        ],
      })
      var waterTotal = this.waterPie[0]+this.waterPie[1]+this.waterPie[2]+this.waterPie[3]
      myChart4.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        // legend: {
        //   orient: 'vertical',
        //   left: 10,
        //   data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
        // },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          z: 2,
          style: {
            text: '总用水量' + waterTotal + '吨',
            x: 100,
            y: 100,
            textAlign: 'center',
            fill: '#1B3BF5',
            width: 30,
            height: 30,
            fontSize: 14,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: '用水统计',
            type: 'pie',
            radius: ['42%', '64%'],
            hoverAnimation: false,
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = ['#F8B51F', '#F65D26', '#AEC9FF', '#248EFF']
                  return colorList[params.dataIndex]
                },
              },
            },
            label: {
              normal: {
                show: true,
                position: 'outside',
                formatter: '{b}\n{c}吨',
                textStyle: {
                  fontSize: '12',
                  fontWeight: 'bold',
                },
                emphasis: {
                  show: true,
                },
              },
            },
            labelLine: {
              show: true,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold',
              },
            },
            data: [
              { value: this.waterPie[0], name: '一季度' },
              { value: this.waterPie[1], name: '二季度' },
              { value: this.waterPie[2], name: '三季度' },
              { value: this.waterPie[3], name: '四季度' },
            ],
          },
        ],
      })
    },
    handleCommand(command) {
      this.year = command
    },
  },
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.is-selected {
  color: #3ec83e;
  margin: 10px;
}

.box-card {
  position: relative;
  /* padding: 10px; */
  cursor: pointer;
}
.item {
  padding: 20px 0;
  position: absolute;
  left: 18px;
  top: -10px;
}

.page2 .month-pie,
.page2 .content {
  position: absolute;
  top: 20px;
  left: 25px;
  font-size: 18px;
  font-weight: bold;
  color: #707070;
}

.txt-year {
  width: 80px;
}

.content >>> .el-input__inner {
  border: 0 none;
  height: auto;
  line-height: 20px;
  font-size: 18px;
  padding: 0;
}

.content >>> .el-input__suffix {
  right: 120px;
}

.content >>> .el-input--suffix .el-input__inner {
  padding-right: 0;
  height: auto;
}

.content >>> .el-select .el-input__inner {
  padding-right: 0;
}

.content >>> .el-input__icon {
  height: auto;
  line-height: 20px;
}

.card-con {
  height: 70px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.card-num {
  width: 60%;
  padding: 18px;
}

.card-num span {
  font-size: 30px;
  color: #1b3bf5;
  font-weight: bold;
}

.card-num img {
  top: -7px;
  position: relative;
}

.color1 span {
  color: #4ecbff;
}

.color2 span {
  color: #ffbc01;
}
.page2 .el-row:nth-child(2) .el-col .el-card,
.page2 .el-row:nth-child(4) .el-col .el-card {
  height: 360px;
}

.page2 .el-row:nth-child(4) {
  margin-bottom: 30px;
}

.page2 .el-col {
  margin-top: 20px;
  border-radius: 4px;
}

.text {
  font-size: 16px;
}
.contenttxt-year {
  position: absolute;
  top: 8px;
  right: 0px;
  z-index: 1;
}
</style>